/**
 * EastSupplier Trust banner — industrial supply-chain network (Canvas)
 */
(function () {
  'use strict';

  function initTrustCanvas(root) {
    if (root.dataset.esCanvasInit === '1') return;
    root.dataset.esCanvasInit = '1';

    var canvas = root.querySelector('[data-trust-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var layState = { lastW: 0, lastH: 0 };
    var time = 0;
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var nodes = [];
    var particles = [];
    var beams = [];

    var ORANGE = '#ff6128';
    var TEAL = '#2a6b7a';
    var TEAL_LIGHT = '#4a9aad';

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function buildScene() {
      nodes = [];
      particles = [];
      beams = [];

      var cols = Math.max(5, Math.floor(w / 140));
      var rows = Math.max(4, Math.floor(h / 100));

      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          nodes.push({
            x: (c / Math.max(1, cols - 1)) * w * 0.92 + w * 0.04 + rand(-12, 12),
            y: (r / Math.max(1, rows - 1)) * h * 0.85 + h * 0.08 + rand(-10, 10),
            pulse: rand(0, Math.PI * 2),
            size: rand(1.5, 3)
          });
        }
      }

      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var links = 0;
        for (var j = i + 1; j < nodes.length && links < 2; j++) {
          var m = nodes[j];
          var dist = Math.hypot(n.x - m.x, n.y - m.y);
          if (dist < w / (cols - 0.5) * 1.1) {
            particles.push({
              from: i,
              to: j,
              t: rand(0, 1),
              speed: rand(0.08, 0.18)
            });
            links++;
          }
        }
      }

      var beamCount = Math.max(8, Math.floor(w / 100));
      for (var b = 0; b < beamCount; b++) {
        beams.push({
          x1: rand(0, w),
          y1: rand(0, h * 0.35),
          x2: rand(0, w),
          y2: rand(h * 0.2, h),
          opacity: rand(0.04, 0.12),
          width: rand(1, 2.5)
        });
      }
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, root, { minW: 320, minH: 280, state: layState });
        w = m.w;
        h = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, w, h, dpr);
      } else {
        var rect = (canvas.parentElement || root).getBoundingClientRect();
        w = Math.max(320, rect.width);
        h = Math.max(280, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildScene();
    }

    function drawBackground() {
      var g = ctx.createLinearGradient(0, 0, 0, h);
      g.addColorStop(0, '#0b1a24');
      g.addColorStop(0.4, '#0f2633');
      g.addColorStop(0.75, '#122d3a');
      g.addColorStop(1, '#0a1820');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      var rg = ctx.createRadialGradient(w * 0.5, h * 0.35, 0, w * 0.5, h * 0.4, w * 0.65);
      rg.addColorStop(0, 'rgba(42, 107, 122, 0.25)');
      rg.addColorStop(0.5, 'rgba(255, 97, 40, 0.06)');
      rg.addColorStop(1, 'rgba(0, 0, 0, 0)');
      ctx.fillStyle = rg;
      ctx.fillRect(0, 0, w, h);
    }

    function drawBeams() {
      beams.forEach(function (b) {
        ctx.save();
        ctx.globalAlpha = b.opacity;
        ctx.strokeStyle = TEAL_LIGHT;
        ctx.lineWidth = b.width;
        ctx.beginPath();
        ctx.moveTo(b.x1, b.y1);
        ctx.lineTo(b.x2, b.y2);
        ctx.stroke();
        ctx.restore();
      });

      ctx.save();
      ctx.globalAlpha = 0.06;
      ctx.strokeStyle = '#5a8a9a';
      ctx.lineWidth = 1;
      for (var x = 0; x < w; x += 48) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x + h * 0.15, h);
        ctx.stroke();
      }
      ctx.restore();
    }

    function drawNetwork(t) {
      particles.forEach(function (p) {
        var a = nodes[p.from];
        var b = nodes[p.to];
        if (!a || !b) return;

        ctx.save();
        ctx.globalAlpha = 0.15;
        ctx.strokeStyle = TEAL_LIGHT;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
        ctx.restore();

        if (!reducedMotion) p.t += p.speed * 0.012;
        if (p.t > 1) p.t = 0;

        var px = a.x + (b.x - a.x) * p.t;
        var py = a.y + (b.y - a.y) * p.t;
        var glow = 0.5 + 0.5 * Math.sin(t * 4 + p.t * 10);

        ctx.save();
        ctx.globalAlpha = 0.35 + glow * 0.45;
        ctx.fillStyle = p.t > 0.45 && p.t < 0.55 ? ORANGE : TEAL_LIGHT;
        ctx.beginPath();
        ctx.arc(px, py, 2 + glow, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });

      nodes.forEach(function (n) {
        var pulse = reducedMotion ? 0.7 : 0.45 + 0.35 * Math.sin(t * 1.8 + n.pulse);
        ctx.save();
        ctx.globalAlpha = pulse * 0.5;
        ctx.fillStyle = TEAL_LIGHT;
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });
    }

    function drawVignette() {
      var v = ctx.createRadialGradient(w * 0.5, h * 0.5, h * 0.2, w * 0.5, h * 0.5, h * 0.85);
      v.addColorStop(0, 'rgba(0,0,0,0)');
      v.addColorStop(1, 'rgba(0,0,0,0.45)');
      ctx.fillStyle = v;
      ctx.fillRect(0, 0, w, h);
    }

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(w * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(h * dpr)) * 0.5) {
        resize();
      }
      if (!reducedMotion) time = ts * 0.001;

      ctx.clearRect(0, 0, w, h);
      drawBackground();
      drawBeams();
      drawNetwork(time);
      drawVignette();

      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resize();
            start();
          } else stop();
        });
      }).observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var br = root.getBoundingClientRect();
        if (br.bottom > 0 && br.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-es-trust-canvas]').forEach(initTrustCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
